module.exports = ".as-dialog {\r\n\tmargin-bottom:0 !important;\r\n}\r\n.close {\r\n\tcolor: #fff;\r\n\tright: 0;\r\n\tposition: fixed;\r\n\tpadding: .3em 1em;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/ssn-bg/ssn-bg.component.css
// module id = ./src/app/shared/components/ssn-bg/ssn-bg.component.css
// module chunks = main